import { Icon } from '@iconify/react';
import { useTranslation } from 'react-i18next';
import { McpForm } from '@/Domain/components/Integration/McpIntegration/McpForm/McpForm';
import { McpIntegration } from '@/Domain/components/Integration/McpIntegration/McpIntegration/McpIntegration';
import { IconButton } from '@/Domain/components/Shared/Button/Button';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@/Domain/components/Shared/Sheet/sheet';
import { Switch } from '@/Domain/components/Shared/Switch/Switch';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/Domain/components/Shared/Tabs/Tabs';
import CloseIcon from '@/Domain/components/icons/Close.icon';
import { useMcpForm } from '@/Domain/hooks/Action/useMcpForm/useMcpForm';
import { MODAL_NAMES, useModalStore } from '@/Domain/store/modal.store';

enum McpPageTabsEnum {
  Settings = 'settings',
  Integration = 'integration',
}

export const McpIntegrationSheet = () => {
  const { t } = useTranslation('mcp_page');

  const { isOpen, closeModal } = useModalStore();

  const { data, handleMutation } = useMcpForm();

  return (
    <Sheet open={isOpen(MODAL_NAMES.MCP_INTEGRATION_SHEET)} onOpenChange={closeModal}>
      <SheetContent className="max-w-3xl w-full h-full" tabIndex={undefined}>
        <SheetHeader className="px-0.5">
          <SheetTitle>{t('title')}</SheetTitle>
          <section className="flex items-center gap-2">
            <IconButton onClick={() => closeModal()} variant="secondary">
              <CloseIcon />
            </IconButton>
          </section>
        </SheetHeader>
        <div className="overflow-y-auto px-0.5">
          <div className="rounded-xl bg-muted mb-8">
            <div className="py-6 pl-6 pr-6 xl:pr-0 flex flex-col justify-between gap-1">
              <div className="flex items-center gap-3.5">
                <h3 className="font-semibold">{t('banner.title')}</h3>

                <Switch
                  checked={data?.active}
                  onCheckedChange={(checked) => handleMutation({ active: checked })}
                />
              </div>

              <p className="text-sm text-muted-foreground">{t('banner.description')}</p>
              <section className="flex items-center gap-2">
                <a
                  href="https://www.quickchat.ai/post/how-to-launch-your-quickchat-ai-mcp"
                  className="text-sm font-medium text-foreground flex items-center gap-1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('banner.docs')}
                  <Icon icon="mingcute:arrow-right-up-line" />
                </a>
                <a
                  href="https://www.youtube.com/watch?v=JE3dNiyZO8w"
                  className="text-sm font-medium text-foreground flex items-center gap-1"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {t('banner.video')}
                  <Icon icon="mingcute:youtube-fill" />
                </a>
              </section>
            </div>
          </div>

          <Tabs defaultValue={McpPageTabsEnum.Settings}>
            <TabsList className="mb-6">
              <TabsTrigger value={McpPageTabsEnum.Settings}>{t('tabs.settings')}</TabsTrigger>
              <TabsTrigger value={McpPageTabsEnum.Integration}>{t('tabs.integration')}</TabsTrigger>
            </TabsList>
            <TabsContent value={McpPageTabsEnum.Settings}>
              <McpForm />
            </TabsContent>
            <TabsContent value={McpPageTabsEnum.Integration}>
              <McpIntegration />
            </TabsContent>
          </Tabs>
        </div>
      </SheetContent>
    </Sheet>
  );
};
